import * as types from "./actionTypes";
import * as constants from "../constants/DomainConstants";
import mijnDossierApi from "../api/mijnDossierApi";
import * as ajax from "./ajaxCounterActions";
import * as exception from "./exceptionActions";
import * as beads from "./beadActions";

// ----------------------------------------------------------------------------
export function mijnDossierLoaded(dossier) {
	return {
		type: types.MIJN_DOSSIER_LOADED,
		body: dossier
		
	};
}

export function loadMijnDossier(dossierId) {
	return (dispatch) => {
		dispatch(ajax.started());

		return mijnDossierApi.get(dossierId)
			.then(response => {
				dispatch(ajax.ended());
				dispatch(mijnDossierLoaded(response.data));
				dispatch(beads.beadsLoaded(response.data.beadModels));
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}